// import * as Config from '../../../config';
import React, { useState } from 'react';
import { connect } from "react-redux";
import PropTypes from 'prop-types';
import './Chat.css';

// import IconSend from './svg/IconSend';
import ChatPause from './svg/ChatPause';
import { setStateShortcuts } from "../shortcut/redux/actions/index";

function ConnectedInputMessageSocket({
  socket, roomID, userSession, isOutsider = false, onFocus, onBlur, withPause, onPauseClick,
  className,
  storeAuth
}) {
  const [content, setContent] = useState(``);
  const [lock, setLock] = useState(false);
  const onChange = (e) => { setContent(e.target.value) };
  const onEnterPress = (e) => { if (e.charCode === 13) { send(); } };
  const send = () => {
    if (socket && content.length > 0 && !lock) {
      socket.emit("send message to room", { content, roomID });
      setContent('');
      setLock(true);
      setTimeout(() => { setLock(false); }, 1000);
    }
  }

  const overFocus = () => {
    if (isOutsider) {
      storeAuth.signupPM();
    }
  }

  return (
    <div className={`flexRow input-chat ${className}`} style={{gap: 6}}>
      <div className={`search-advanced search-box chat-input ${withPause ? 'reduce' : ''}`} onClick={overFocus} >
        <input id={'input-chat'} type="text" placeholder={((userSession && userSession.mute) || isOutsider) ? `You are mute` : `Send a message`} value={content} disabled={((userSession && userSession.mute) || isOutsider)}
          onChange={onChange} onKeyPress={onEnterPress} onFocus={onFocus} onBlur={onBlur}
          className={`search-input focus type-regular bg-black-1`}
        />
        { /* <IconSend color={content.length > 0 ? Config.BRAND_PRIMARY : Config.GREY_1} onClick={send} style={{ position: `absolute`, right: 8, top: 6, cursor: `pointer` }} /> */ }
      </div>
      { withPause && <ChatPause className={`chat-pause`} onClick={onPauseClick} /> }
      <div className={`button-send-chat type-medium fz13 ${content.length > 0 && 'primary'}`} onClick={send}>Send</div>
    </div>
  )
}

ConnectedInputMessageSocket.propTypes = {
  socket: PropTypes.object.isRequired,
  roomID: PropTypes.any.isRequired,
  userSession: PropTypes.object,
  isOutsider: PropTypes.bool,
  onFocus: PropTypes.func,
  onBlur: PropTypes.func,
  withPause: PropTypes.bool,
  onPauseClick: PropTypes.func,
  className: PropTypes.string
}

const InputMessageSocket = connect(
  state => ({
    socket: state.socketPM,
    roomID: state.inRoomPM ? state.inRoomPM.id : null,
    userSession: state.playersInRoomPM.find(x => (state.user && x.id === state.user.id)),
    isOutsider: state.isOutsider,
    storeAuth: state.storeAuth
  }),
  (dispatch, ownProps) => ({
    onFocus: () => { dispatch(setStateShortcuts(false)) },
    onBlur: () => { dispatch(setStateShortcuts(true)) }
  })
)(ConnectedInputMessageSocket);

export default InputMessageSocket;
